import { ChildrenItem } from "dependencies/base"
import { Text } from "./model"
import {
  home,
  bs,
  appHome,
  dialog,
  detailPrevPage,
  detailNextPage,
  appDetailPrevPage,
  appDetailNextPage
} from "./diffrence_options"
// import icon from "../../assets/images/leftMenu/basePortal/icon_text2.png"
import bigScreenIcon from "assets/images/leftMenu/base/cx_text.png"

let icon = "icon-portal-menu_text1"
export let text_children = []
export let bs_text_children = []
export let app_text_children = []
export let dialog_children = []
export let detail_prev_children = []
export let detail_next_children = []
export let app_detail_prev_children = []
export let app_detail_next_children = []
for (let i = 0; i < home.length; i++) {
  text_children.push(new ChildrenItem("文本样式" + i, icon, "cxText", new Text(home[i])))
}
for (let i = 0; i < bs.length; i++) {
  bs_text_children.push(new ChildrenItem("文本样式" + i, bigScreenIcon, "cxText", new Text(bs[i])))
}
for (let i = 0; i < appHome.length; i++) {
  app_text_children.push(new ChildrenItem("文本样式" + i, icon, "cxText", new Text(appHome[i])))
}
// 上一篇下一篇组件
for (let i = 0; i < detailPrevPage.length; i++) {
  detail_prev_children.push(new ChildrenItem("文本样式" + i, "icon-portal-text_previous", "cxText", new Text(detailPrevPage[i])))
}
for (let i = 0; i < detailNextPage.length; i++) {
  detail_next_children.push(new ChildrenItem("文本样式" + i, "icon-portal-text_next", "cxText", new Text(detailNextPage[i])))
}
for (let i = 0; i < appDetailPrevPage.length; i++) {
  app_detail_prev_children.push(new ChildrenItem("文本样式" + i, "icon-portal-text_previous", "cxText", new Text(appDetailPrevPage[i])))
}
for (let i = 0; i < appDetailNextPage.length; i++) {
  app_detail_next_children.push(new ChildrenItem("文本样式" + i, "icon-portal-text_next", "cxText", new Text(appDetailNextPage[i])))
}
